import LoginForm from './styled';

export default LoginForm;
